import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/Header'
import './index.css'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Hampshire Web Design and Development | Nathan Gaw"
      meta={[
        { name: 'description', content: 'Hampshire-based website designer/developer. High quality websites that will build your business.' },
        { name: 'keywords', content: 'nothing to see here...' },
      ]}
        
    />
    <div>
      {children()}
    </div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js